import { render, staticRenderFns } from "./ApplicantSection.vue?vue&type=template&id=562cac0f&"
import script from "./ApplicantSection.vue?vue&type=script&lang=js&"
export * from "./ApplicantSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports